import React from 'react' // eslint-disable-line

import styled from 'styled-components'
const tabletWidth = 1200
const mobileWidth = 980
export const WhySaatchi = styled.div`
  background: #f9f9f9;
  display: flex;
  flex-direction: row;
  padding: 80px 165px 80px 163px;
  justify-content: center;
  align-items: center;
  [data-style='why-saatchi-subtitle'] {
    margin: 0 155px 0 0;
    width: 308px;
    text-wrap: nowrap;
  }
  [data-style='hide'] {
    display: none;
  }
  [data-style='why-saatchi-text'] {
    max-width: 650px;
    line-height: 32px;
    margin: 0;
  }
  @media (max-width: ${tabletWidth}px) {
    padding: 80px 48px 80px 48px;
  }
  @media (max-width: ${mobileWidth}px) {
    padding: 60px 24px 60px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    [data-type='subtitle'] {
      margin: 0;
      &[data-style='why-saatchi-subtitle'] {
        margin-bottom: 16px;
        }
    }
    [data-type='text'] {
      text-align: center;
    }
  }
`